import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {UserPerformanceDefaultsComponent} from "../../project-defaults/user-performance-defaults/user-performance-defaults.component";
import {StringUtils} from "../../utils/string-utils";
import {MatProgressSpinner} from "@angular/material/progress-spinner";

import {MatDialogRef} from "@angular/material/dialog";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-user-performance-defaults-dialog',
    imports: [
    UserPerformanceDefaultsComponent,
    MatProgressSpinner,
    MatButton
],
    templateUrl: './user-performance-defaults-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './user-performance-defaults-dialog.component.css'
})
export class UserPerformanceDefaultsDialogComponent {
  readonly dialogRef = inject<MatDialogRef<UserPerformanceDefaultsDialogComponent>>(MatDialogRef);


  errorMessage!: string;
  isBusy!: boolean;

  handleError(error: any): void {
    this.isBusy = false;
    this.errorMessage = StringUtils.getErrorMessage(error);
  }

  close(): void {
    this.dialogRef.close();
  }

}
